import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-candidate-status-popover',
  templateUrl: './candidate-status-popover.component.html',
  styleUrls: ['./candidate-status-popover.component.scss']
})
export class CandidateStatusPopoverComponent {
  @HostBinding('class.leave-status-popover') hasClass = true;

  @Input() statusList: any[] = [];
  @Input() applicationStatus!: string;
  @Input() currentUserId!: string;
  @Input() forceApplicationStatus = false;

  displayStatus!: string;

  ngOnInit() {
    this.resolveDisplayStatus();
  }

  ngOnChanges() {
    this.resolveDisplayStatus();
  }

  private resolveDisplayStatus() {
    if (this.forceApplicationStatus) {
      this.displayStatus = this.applicationStatus;
      return;
    }

    const myApproval = this.statusList?.find(
      a => a.approverId === this.currentUserId
    );

    if (myApproval) {
      this.displayStatus = myApproval.status;
      return;
    }

    this.displayStatus = this.applicationStatus;
  }

  getBadgeClass(status: string): string {
    switch (status) {
      case 'InterviewCompleted':
      case 'Hired':
        return 'bg-info';
      case 'Recommended':
      case 'Offered':
      case 'Approved':
        return 'bg-success';
      case 'NotRecommended':
      case 'Rejected':
        return 'bg-danger';
      default:
        return 'bg-warning';
    }
  }

  getStatusShort(status: string): string {
    switch (status) {
      case 'Pending': return 'P';
      case 'Recommended': return 'A';
      case 'InterviewCompleted': return 'C';
      case 'InterviewAgain': return 'IA';
      case 'Offered': return 'O';
      case 'FinalInterview': return 'FI';
      case 'Rejected': return 'R';
      default: return status?.charAt(0) ?? '';
    }
  }
}
